const resource = '/v1/templates'

export default $axios => ({
  getTemplateForUser() {
    return $axios.get(`${resource}`);
  },

  getLsTemplates() {
    return $axios.get(`${resource}/get-ls-templates`);
  },

  getRandomLsTemplates(payload) {
    return $axios.get(`${resource}/get-random-ls-templates${ payload.limit ? '?limit_record=' + payload.limit : ''}` );
  },

  updateCompanyModalPriority(payload) {
    return $axios.put(`${resource}/update-company-modal-priority`, payload)
  },

  search(payload) {
    return $axios.post(`${resource}/search`, payload);
  },

  getDetail(id) {
    return $axios.get(`${resource}/${id}`);
  },

  /**
   * Create template
   *
   * @param {FormData} payload
   *
   * @returns {Promise}
   */
  create(payload) {
    return $axios.post(resource, payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  /**
   * Update template
   *
   * @param {FormData} payload
   *
   * @returns {Promise}
   */
  update(payload) {
    return $axios.post(`${resource}/${payload.get('id')}`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  createProposal(payload) {
    return $axios.post(`${resource}/create-proposal`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  saveAsManual(id) {
    return $axios.post(`${resource}/save-as-manual`, {id});
  },
  delete(id) {
    return $axios.delete(`${resource}/${id}`);
  }
});
